<template>
    <main-layout>2</main-layout>
</template>

<script>
    import MainLayout from "../components/MainLayout.vue";

    export default {
        name: "HomePage",
        components: {
            MainLayout,
        },
    };
</script>

<style scoped>
</style>